import * as comConstants from "common/constants";


let data = {};
data = Object.assign(data, comConstants);

const context = require.context('json-loader!yaml-loader!constants/', false, /\.(yaml)$/);
context.keys().forEach((filename)=>{
  data = Object.assign(data, context(filename));
});

export default data;



